import { render } from "./BankAccountWidget.vue?vue&type=template&id=8a562da8"
import script from "./BankAccountWidget.vue?vue&type=script&lang=js"
export * from "./BankAccountWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__